import { apiClient } from './client';
import type { ClientsPageMeta } from './clients';

/**
 * Строка "Журнал событий ЛК" — GET /events/client, 1:1 старый Orchid
 * EventListScreen (см. докблок EventsController в Laravel).
 */
export interface ClientEventRow {
  id: number;
  createdAt: string;
  accountName: string | null;
  category: string | null;
  name: string | null;
  object: string | null;
  status: string | null;
  description: string | null;
  email: string | null;
  fio: string | null;
  role: string | null;
  emailLogin: string | null;
  ipAddress: string | null;
}

export interface FetchClientEventsParams {
  search?: string;
  category?: string;
  status?: string;
  role?: string;
  sort?: string;
  page?: number;
}

export interface ClientEventsPage {
  items: ClientEventRow[];
  meta: ClientsPageMeta;
}

export async function fetchClientEvents(params: FetchClientEventsParams = {}): Promise<ClientEventsPage> {
  const { data } = await apiClient.get<ClientEventsPage>('/events/client', { params });
  return data;
}

/** Роли для фильтра "Роль" на вкладке "Журнал событий ЛК" — роли пользователей клиентских кабинетов, не то же самое, что роли админов. */
export async function fetchClientEventRoles(): Promise<string[]> {
  const { data } = await apiClient.get<string[]>('/events/client/roles');
  return data;
}

/**
 * Строка "Журнал событий админки" — GET /events/admin, 1:1 старый Orchid
 * EventListAdminScreen.
 */
export interface AdminEventRow {
  id: number;
  createdAt: string;
  name: string | null;
  object: string | null;
  status: string | null;
  fullName: string | null;
  role: string | null;
  email: string | null;
  ipAddress: string | null;
}

export interface FetchAdminEventsParams {
  status?: string;
  role?: string;
  sort?: string;
  page?: number;
}

export interface AdminEventsPage {
  items: AdminEventRow[];
  meta: ClientsPageMeta;
}

export async function fetchAdminEvents(params: FetchAdminEventsParams = {}): Promise<AdminEventsPage> {
  const { data } = await apiClient.get<AdminEventsPage>('/events/admin', { params });
  return data;
}

/** Роли для фильтра "Роль" на вкладке "Журнал событий админки". */
export async function fetchAdminEventRoles(): Promise<string[]> {
  const { data } = await apiClient.get<string[]>('/events/admin/roles');
  return data;
}
